import { BlocksTableHeader } from 'blocks-nextjs/blocks-web-components/components/table-header/table-header';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatTableHeader = createComponent({ react: React, tagName: 'cat-table-header', elementClass: BlocksTableHeader });
